var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('div',{ref:"clientContainer",staticClass:"md-layout-item md-size-100 client-container"},[_c('transition',{attrs:{"name":"bounce"}},[(_vm.selectedClient)?_c('Client',{attrs:{"client":_vm.selectedClient},on:{"hideClient":_vm.hideClient,"saveClient":_vm.getClients}}):_vm._e()],1)],1),_c('SearchTable',{ref:"table",attrs:{"header":{
      title: 'Klijenti',
      icon: 'recent_actors',
      class: 'md-card-header-brand',
    },"queriedData":_vm.clients,"metaData":_vm.metaData,"getItems":_vm.getClients,"params":_vm.params,"sortBy":'id',"newItem":_vm.createClient,"templates":_vm.templates,"openItem":_vm.openClient,"forEachSelected":[
      {
        icon: 'delete',
        label: 'Briši',
        class: 'md-danger',
        function: _vm.deleteClients,
      } ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }